import { render } from "./SapicoPasswordPageHeaderCmp.vue?vue&type=template&id=7867ee59"
import script from "./SapicoPasswordPageHeaderCmp.vue?vue&type=script&lang=js"
export * from "./SapicoPasswordPageHeaderCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__